export default {
	geoSerp: '/admin/serp/geo', // 国家地区关键字排名
	argRankAndKey: '/admin/serp/service', // 平均排名和关键字排名
	keywordUrlRank: '/admin/serp/landing-pate', // 有关键词的排名-落地页
	top10Keyword: '/admin/serp/keywords', // 前10名关键词
	viewPicture: '/admin/serp/{taskInstanceResultId}', // 查看快照
	keyword: '/admin/serp/keywords?serviceSiteId={serviceSiteId}', // 详细数据列表
	serpReportTask: '/admin/serp/serp-report-task', // 添加serp报表任务
	serpReportTaskList: '/admin/serp/serp-report-task/list', // serp报表任务列表
	serpReportTaskListAgain: '/admin/serp/serp-report-task/again/{id}', // serp报表任务列表重新生成
};
